import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { lazy, Suspense } from 'react';

const HomePage = lazy(() => import('@/app/page'));
const CartPage = lazy(() => import('@/app/cart/page'));
const CheckoutPage = lazy(() => import('@/app/checkout/page'));
const LoginPage = lazy(() => import('@/app/login/page'));
const RegisterPage = lazy(() => import('@/app/register/page'));
const ForgotPasswordPage = lazy(() => import('@/app/forgot-password/page'));
const ResetPasswordPage = lazy(() => import('@/app/reset-password/page'));
const WishlistPage = lazy(() => import('@/app/wishlist/page'));
const ProfilePage = lazy(() => import('@/app/profile/page'));
const OrdersPage = lazy(() => import('@/app/orders/page'));
const OrderPage = lazy(() => import('@/app/orders/[id]/page'));
const ProductPage = lazy(() => import('@/app/products/[id]/page'));
const ProductSearchPage = lazy(() => import('@/app/products/search/page'));
const ProductWishlistPage = lazy(() => import('@/app/products/wishlist/page'));
const CategoryPage = lazy(() => import('@/app/categories/[id]/page'));
const ProductTypePage = lazy(() => import('@/app/product-types/[id]/page'));
const SubCategoryPage = lazy(() => import('@/app/sub-categories/[id]/page'));
const PreviewPage = lazy(() => import('@/app/preview/page'));
const PreviewPresetPage = lazy(() => import('@/app/preview-preset/page'));

const PageLoader = () => (
  <div className="flex items-center justify-center h-screen">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
  </div>
);

export function AppRouter() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/wishlist" element={<WishlistPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/orders" element={<OrdersPage />} />
        <Route path="/orders/:id" element={<OrderPage />} />
        <Route path="/products/:id" element={<ProductPage />} />
        <Route path="/products/search" element={<ProductSearchPage />} />
        <Route path="/products/wishlist" element={<ProductWishlistPage />} />
        <Route path="/categories/:id" element={<CategoryPage />} />
        <Route path="/product-types/:id" element={<ProductTypePage />} />
        <Route path="/sub-categories/:id" element={<SubCategoryPage />} />
        <Route path="/preview" element={<PreviewPage />} />
        <Route path="/preview-preset" element={<PreviewPresetPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
}
